import slugify from "slugify";
import base58 from "../base58";

export type Creation = {
  id: string;
  owner: string;
  prompt: string;
  promptTranslated: string;
  public: boolean;
  status: string;
  createdAt: string;
  updatedAt: string;
  style: string[];
  imagePaths: string[];
  svgPaths: string[];
  modifiers: string[];
  tags: string[];
  bodyPart: string;
  params: Record<string, any>;
  rank: number;
  fts: string;
  featured: boolean;
  error: string;
};

export function getCreationSlug(creation: Creation, includeId = true) {
  let slug = `${slugify(trimEllip(creation.prompt, 40, ""), {
    lower: true,
    strict: true,
  })}`;
  if (includeId) {
    slug += `-${base58.encode(creation.id)}`;
  }
  return slug;
}

export function getCreationUrl(creation: Creation, variant?: number) {
  if (variant !== undefined && variant !== 0) {
    return `/styles/${creation.style[0]}/${getCreationSlug(
      creation
    )}?variant=${variant}`;
  }
  return `/styles/${creation.style[0]}/${getCreationSlug(creation)}`;
}

/**
 * @deprecated use getCreationSingleURLv2
 * @param creation
 * @param variant
 */
export function getCreationSingleUrl(creation: Creation, variant?: number) {
  if (variant === undefined) {
    return `/shop/temporary-tattoos/${getCreationSlug(creation)}`;
  }
  return `/shop/temporary-tattoos/${getCreationSlug(
    creation
  )}?variant=${variant}`;
}

export function getCreationSingleURLv2(creation: Creation, variant?: number) {
  if (variant === undefined) {
    return `/products/${getCreationSlug(creation)}`;
  }
  return `/products/${getCreationSlug(creation)}?variant=${variant}`;
}

export function titleize(str: string) {
  if (!str.length) return "(Random)";
  return str
    .trim()
    .split(" ")
    .map((w) => {
      if (!w.length) return "";
      // Find first letter character
      for (let i = 0; i < w.length; i++) {
        if (/[a-zA-Z]/.test(w[i])) {
          return (
            w.substring(0, i) +
            w[i].toUpperCase() +
            w.substring(i + 1).toLowerCase()
          );
        }
      }
      // No letters found, return original word
      return w;
    })
    .join(" ");
}

export function trimEllip(str: string, length: number, ellip = "...") {
  if (!str.length) return "";

  const trimmedStr = str.substring(0, length);

  const trimmedOutput = `${trimmedStr.substring(
    0,
    Math.min(trimmedStr.length, trimmedStr.lastIndexOf(" "))
  )}${ellip}`;

  return str.length > length ? trimmedOutput : str;
}

export function convertToFirstNameAndInitials(fullName: string | null) {
  if (!fullName) return "Anonymous";
  // Split the full name into parts
  const nameParts = fullName.trim().split(/\s+/);

  // Extract the first name
  const firstName = nameParts[0];

  // Convert middle and last names into initials
  const initials = nameParts
    .slice(1)
    .map((name) => `${name.charAt(0)}.`)
    .join("");

  // Combine first name and initials
  return `${firstName} ${initials}`;
}
